var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollBody",style:(_vm.bodyStyle)},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }